export default __webpack_public_path__ + "static/media/ai_regenerate_icon.4e950f23.svg";